import { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { pagesAPI } from '../lib/api';

export default function TermsPage() {
    const [page, setPage] = useState({ title: 'Terms of Service', content: '' });
    const [, setLoading] = useState(true);

    useEffect(() => {
        fetchPage();
    }, []);

    const fetchPage = async () => {
        try {
            const response = await pagesAPI.getTerms();
            if (response.data) setPage(response.data);
        } catch (error) {
            // Using default content
        } finally {
            setLoading(false);
        }
    };

    const defaultContent = `
## Terms of Service

### 1. Introduction
Welcome to our website. By accessing this website, you agree to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws.

### 2. Use License
Permission is granted to temporarily download one copy of the materials (information or software) on our website for personal, non-commercial transitory viewing only.

### 3. Disclaimer
The materials on our website are provided on an 'as is' basis. We make no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.

### 4. Limitations
In no event shall we or our suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on our website.
  `;

    return (
        <div className="max-w-4xl mx-auto px-4 py-12" data-testid="terms-page">
            <Card>
                <CardHeader>
                    <CardTitle className="text-3xl">{page.title}</CardTitle>
                </CardHeader>
                <CardContent>
                    <div className="prose prose-slate dark:prose-invert max-w-none">
                        <div className="whitespace-pre-wrap text-muted-foreground leading-relaxed">
                            {page.content || defaultContent}
                        </div>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
